/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
    window.$ = jQuery || window.jQuery || require('jquery');
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch(error) {}

import AOS from 'aos';
import Headroom from 'headroom.js';
import lightcase from 'lightcase/src/js/lightcase';
import EasyRead from './easyread';
import ResourcesSearch from './resources';
import NewsSearch from './news';
import EventsSearch from './events';
import SubmissionsSearchSearch from './submissions';

var mobileThreshold = 992;
var isMobile = window.innerWidth < mobileThreshold;

// easy read
new EasyRead();

// Handle the hamburger click animation
$('.hamburger').click(function() {
	$(this).toggleClass('is-active');

	if( $(this).hasClass('is-active') ) {
		$('body,html').addClass('mobile-menu-open');
	} else {
		$('body,html').removeClass('mobile-menu-open');
	}
});

// Add Bootstrap responsive class around table elements
$('table').each(function() {
    $(this).addClass('table')
    $(this).parent().addClass('table-responsive');
});

// Add Bootstrap stripe class to table
$('.wp-block-table.is-style-stripes table').each(function() {
    $(this).addClass('table-striped')
})

// Add Bootstrap responsive embed class wrapper to required elements
$('iframe[src*="youtube"], iframe[src*="vimeo"]').each(function(){
    $(this).addClass('embed-responsive-item')
    .wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
});

// remove 'aspect ratio' style from spotify embed
$('.wp-block-embed.is-provider-spotify').removeClass('wp-has-aspect-ratio');


const header = document.querySelector('.headroom');
const navBar = document.getElementById('primaryNavigation');
const app 	 = document.querySelector('#app');

// Initialize the Headroom library
let headroom = new Headroom(header, {
    // vertical offset in px before element is first unpinned
    offset : header.offsetHeight,
    // scroll tolerance in px before state changes
    tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },
    // css classes to apply
    classes : {
        // when element is initialised
        initial : "headroom",
        // when scrolling up
        pinned : "headroom--pinned",
        // when scrolling down
        unpinned : "headroom--unpinned",
        // when above offset
        top : "headroom--top",
        // when below offset
        notTop : "headroom--not-top",
        // when at bottom of scoll area
        bottom : "headroom--bottom",
        // when not at bottom of scroll area
        notBottom : "headroom--not-bottom",
        // when frozen method has been called
        frozen: "headroom--frozen"
    },
    // element to listen to scroll events on, defaults to `window`
    scroller : window,
    // callback when pinned, `this` is headroom object
    onPin : function() {},
    // callback when unpinned, `this` is headroom object
    onUnpin : function() {
		if(navBar.classList.contains('show')) {
			this.elem.classList.remove(this.classes.unpinned);
			this.elem.classList.add(this.classes.pinned);
		}
		else {
			this.elem.classList.add(this.classes.unpinned);
			this.elem.classList.remove(this.classes.pinned);
		}
	},
    // callback when above offset, `this` is headroom object
    onTop : function() {},
    // callback when below offset, `this` is headroom object
    onNotTop : function() {},
    // callback when at bottom of page, `this` is headroom object
    onBottom : function() {},
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom : function() {}
})
headroom.init();

// Attach Lightcase rel attribute to all gallery anchors
const galleries = document.querySelectorAll('.wp-block-gallery, .gallery');
let galleryInstance = 0;

[...galleries].forEach(gallery => {
    const items = gallery.querySelectorAll('li');
    const anchors = gallery.querySelectorAll('a');
    [...anchors].forEach(anchor => {
        if(! anchor.href.match(/\.(jpg|gif|png|jpeg)$/i)) {
            anchor.href = anchor.querySelector('img').src;
        }
        anchor.setAttribute('data-rel', `lightcase:galleryBlock${galleryInstance}:slideshow`);
    });

    [...items].forEach(item => {
        item.setAttribute('data-aos', 'fade-up');
    })

    galleryInstance++;
})

// Init lightcase
$(document).ready(function(){
    $('a[data-rel^=lightcase]').lightcase({
        maxWidth: 1024,
        maxHeight: 768,

        iframe: {
            width: 1280,
            height: 720,
            allowfullscreen: 1
        }
    });
});

// Initialize the Animate on scroll library
AOS.init();

// Add the loading property to all images in the entry content
const images = document.querySelectorAll('.entry-content img');
[...images].forEach(image => {
    image.loading = 'lazy';
});

const smoothScroll = (event, top = 0, left = 0) => {
    event.preventDefault();
    window.scrollTo({
        top: top,
        left: left,
        behavior: 'smooth'
    });
}

// To top button
$('.btn-to-top').on('click', smoothScroll)

// Add jump links to pages that require it
const jumpLinksContainer = document.querySelector('.jump-links-container');
/*
if(jumpLinksContainer) {
    const headings = document.querySelectorAll('.entry-content h2');

    headings.forEach(heading => {
        const id = heading.innerHTML.replace(/[^0-9a-z]/gi, '')
        const button = document.createElement('a');
        heading.id = id;
        button.href = `#${id}`;
        button.className = 'btn btn-light mb-4 mx-2';
        button.innerHTML = heading.innerHTML;
        button.addEventListener('click', event => {
            smoothScroll(
                event,
            heading.getBoundingClientRect().top + window.scrollY
            )
        })

        jumpLinksContainer.append(button);
    });
}
*/

/**
 * Resource/News searches
 */
new ResourcesSearch();
new NewsSearch();
new EventsSearch();
new SubmissionsSearchSearch();

function dropdown() {
	$("#primaryNavigation .dropdown").each(function () {
		if ($('.dropdown-menu', this).length) {
			var container = $(this).closest('.container');
			var submenu = $('.dropdown-menu', $(this));

			var rightEdge = $(this).offset().left + submenu.innerWidth();
			var containerEdge = container.innerWidth() + container.offset().left;

			if (rightEdge >= containerEdge) {
				submenu.css('left', containerEdge - rightEdge + 'px');
			} else {
				submenu.css('left', '0');
			}
		}
	});

	// open current menu item - mobile only
	if( isMobile ) {
		var $current = $('#primaryNavigation .nav-item').has('.current-page-ancestor, .current-menu-item');
		$('.dropdown-menu', $current).addClass('show');
	} else {
		$('#primaryNavigation .dropdown-menu').removeClass('show');
	}
}
//dropdown();


function onWindowResize() {
	// mobile width?
	isMobile = window.innerWidth < mobileThreshold;

	// Our header is positioned fixed, so let's offset the app element to the headers height
	headroom.offset = header.offsetHeight;
	app.style.paddingTop = `${header.offsetHeight}px`;

	// reset dropdown state
	dropdown();
}

// debounce - redo this if the window size changes
var timeout = 0;
$(window).resize( event => {
	clearTimeout(timeout);
	timeout = setTimeout( () => {
		onWindowResize();
	}, 300)
});

function checkBrowserTabActive() {
	// browser tab visibility checks
	var hidden, visibilityChange;
	if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
		hidden = "hidden";
		visibilityChange = "visibilitychange";
	} else if (typeof document.msHidden !== "undefined") {
		hidden = "msHidden";
		visibilityChange = "msvisibilitychange";
	} else if (typeof document.webkitHidden !== "undefined") {
		hidden = "webkitHidden";
		visibilityChange = "webkitvisibilitychange";
	}

	if (typeof document.addEventListener === "undefined" || hidden === undefined) {
		console.warn("This animation requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
	  } else {
		// Handle page visibility change
		document.addEventListener(visibilityChange, (event)=>{
			if (!document[hidden]) {
				onWindowResize();
			}
		}, false);
	}
}

onWindowResize();
checkBrowserTabActive();